import { localizedLegalPage } from "./localized";
import { SubprocessorsPage as Fr } from "./fr/SubprocessorsPage";
import { SubprocessorsPage as En } from "./en/SubprocessorsPage";

export const SubprocessorsPage = localizedLegalPage({ fr: Fr, en: En });

export default SubprocessorsPage;
